function filterCreditCards(payload) {
    // if this is not an error, ignore it
    if (!payload?.Details?.Error) {
        return payload;
    }

    const { Error: inputError, ...rest } = payload.Details;

    // fields containing potentially sensitive data
    const { Message, StackString } = inputError;

    const filteredData = {
        ...payload,
        Details: {
            ...rest,
            Error: {
                ...inputError,
            },
        },
    };

    if (typeof Message !== 'undefined') {
        filteredData.Details.Error.Message = removeCardNumber(Message);
    }
    if (typeof StackString !== 'undefined') {
        filteredData.Details.Error.StackString = removeCardNumber(StackString);
    }

    return filteredData;
}

// card numbers have 13-19 digits and in crash reports appear in single quotes
function removeCardNumber(input) {
    return input.replace(/'\d{13,19}'/g, '[redacted card number]');
}

export { filterCreditCards, removeCardNumber };
